import { Component } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator
} from '@angular/forms';

@Component({
  selector: 'app-byte-input',
  templateUrl: './byte-input.component.html',
  styleUrls: ['./byte-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ByteInputComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: ByteInputComponent
    }
  ]
})
export class ByteInputComponent implements ControlValueAccessor, Validator {

  public bytesOptions: { name: string, value: number }[] = [ { name: 'Byte 0', value: 0 }, { name: 'Byte 1', value: 1 },
    { name: 'Byte 2', value: 2 }, { name: 'Byte 3', value: 3 }]
  public byte: number = 0;


  constructor() {
    this.valueDecimal = 0;
    this.bitValues = Array(32).fill(false);
  }

  valueDecimal: number;
  bitValues: boolean[];

  touched: boolean = false;
  disabled: boolean = false;

  isInByte(i: number): boolean {
    switch (this.byte) {
      case 0 : return i < 32 && i >= 24;
      case 1 : return i < 24 && i >= 16;
      case 2 : return i < 16 && i >= 8;
      case 3 : return i < 8 && i >= 0;
    }
  }

  onChange = (value): void => {};
  onTouched = (): void => {};

  switchBit(i: number): void {
    this.markAsTouched();
    if (!this.disabled) {
      this.bitValues[i] = !this.bitValues[i];
      this.recalculateDecimalValue();
      this.onChange(this.valueDecimal);
    }
  }

  writeValue(newValue: number): void {
    this.valueDecimal = Number(newValue);
    this.recalculateBitValues();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const newValue = control.value;
    if (newValue < 0) {
      return {
        mustBePositive: { newValue }
      };
    } else if (newValue > 4294967295) {
      return {
        outOfRange: { newValue }
      };
    }
  }

  private markAsTouched(): void {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  private recalculateDecimalValue(): void {
    let newValue: number = 0;
    this.bitValues.forEach((value: boolean, index: number): void => {
      const bitIndex: number = this.bitValues.length - index - 1;
      if (value) { newValue += Math.pow(2, bitIndex); }
    });
    this.valueDecimal = newValue;
  }

  private recalculateBitValues(): void {
    let bitString: string = (this.valueDecimal >>> 0).toString(2);
    while (bitString.length < 32) {
      bitString = '0' + bitString;
    }
    for (let i: number = 0; i < bitString.length; i++) {
      this.bitValues[i] = bitString.charAt(i) === '1';
    }
  }

}
